<template>
  <b-card
    class="card-tiny-line-stats"
    body-class="pb-50"
  >
    <b-card-header>
      <b-card-title class="section-title mb-2">
        {{ $t('Quick Links') }}
      </b-card-title>
    </b-card-header>
    <b-row class="d-flex justify-content-between align-items-start match-height mb-2">
      <!-- Links Section -->
      <b-col
        md="4"
        class="d-flex flex-column"
      >
        <p class="social-title">
          {{ $t('Resources') }}
        </p>
        <ul class="bulletin-list">
          <li
            v-for="(link, index) in websiteLinks"
            :key="index"
          >
            <a
              class="support-label"
              :href="link.url"
              target="_blank"
            >{{ link.label }}</a>
          </li>
        </ul>
      </b-col>

      <!-- Support Section -->
      <b-col
        md="5"
        class="d-flex flex-column"
      >
        <p class="social-title">
          {{ $t('Support') }}
        </p>
        <ul class="bulletin-list">
          <!-- <li>
            <feather-icon
              size="20"
              icon="MailIcon"
            />
            <a
              class="support-label"
              href="mailto:support@fintellia.com"
            >support@fintellia.com</a>
          </li> -->
          <li>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              class="skype-icon"
            >
              <path
                v-for="(path, index) in SkypeIcon.paths"
                :key="index"
                :d="path.d"
                fill="currentColor"
              />
            </svg>
            <a
              class="support-label"
              href="#"
              target="_blank"
            > {{ $t('Skype - Join') }}</a>
          </li>
        </ul>
      </b-col>

      <!-- Social Media Section -->
      <b-col
        md="3"
        class="d-flex flex-column"
      >
        <p class="social-title">
          {{ $t('Follow us on') }}
        </p>
        <ul class="bulletin-list">
          <li
            v-for="(platform, index) in socialPlatforms"
            :key="index"
          >
            <feather-icon
              size="20"
              :icon="platform.icon"
            />
            <a
              class="icons social-media"
              :href="platform.url"
              target="_blank"
            >{{ platform.label }}</a>
          </li>
        </ul>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BRow, BCol, BCard, BCardHeader, BCardTitle,
} from 'bootstrap-vue'
// import { mapGetters } from 'vuex'
import SkypeIcon from '@/helpers/icons'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
  },
  data() {
    return {
      websiteLinks: [
        // { label: 'Fintellia Website', url: 'https://www.fintellia.com' },
        { label: this.$t('User Guide'), url: 'https://docs.udara360.io/udara360-docs-1' },
        { label: this.$t('API Documentation'), url: 'https://docs.udara360.io/udara360-docs-1' },
      ],
      socialPlatforms: [
        { label: 'Facebook', icon: 'FacebookIcon', url: 'https://web.facebook.com/profile.php?id=61559955333713' },
        { label: 'Instagram', icon: 'InstagramIcon', url: 'https://www.instagram.com/fintellia' },
        { label: 'LinkedIn', icon: 'LinkedinIcon', url: 'https://www.linkedin.com/company/fintellia-technologies-limited/' },
      ],
      SkypeIcon,
    }
  },
  // computed: {
  //   ...mapGetters({
  //     corporateInformation: 'operations/getCorporateDetails',
  //     userDetails: 'auth/getCurrentUser',
  //   }),
  // },
}
</script>

<style scoped>
.card .card-header {
    padding: 0.5rem 0;
}
.section-title{
  font-weight: 800;
}
.bulletin-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.bulletin-list li {
  margin-bottom: 0.8rem;
  display: flex;
  align-items: center;
}
.icons {
  margin: 0 1rem;
  font-size: 1.1rem;
}
.social-title {
  font-size: 1.2rem;
  font-weight: bold;
}
.support-label{
  margin: 0 1rem;
  font-size: 1.1rem;
}
.skype-icon {
  width: 20px;
  height: 20px;
  fill: #00aff0; /* Adjust as needed */
}
</style>
